import { useMemo } from 'react';

import { useGetAccountOpportunities } from '~/hooks/apis/offers/useGetOffer';
import { useGetOpportunitiesRelated } from '~/hooks/apis/offers/useGetOpportunityRelated';

import { formatDateISO } from '~/services/TimeService';

import { previousOpportunityChoices } from '../../copyFromPrevious/copyFromPreviousModel';

import { opportunityIdsToRead, usedSfidsOnceLoaded } from './recentInclusionAssets';

// See docs/business-rules.md#recent-assets. Undefined until every read loads, and stays so if one
// fails: nothing is hidden on what couldn't be checked.
export function useRecentAssetSfids(
  accountId: string | undefined,
  opportunityId: string | undefined,
  { enabled = true }: { enabled?: boolean } = {},
) {
  const { data: opportunities, isLoading: isLoadingOpportunities } = useGetAccountOpportunities(accountId, {
    enabled,
  });
  const opportunityIds = useMemo(
    () =>
      enabled && opportunities && opportunityId
        ? opportunityIdsToRead(opportunityId, previousOpportunityChoices(opportunities, opportunityId), formatDateISO())
        : [],
    [enabled, opportunities, opportunityId],
  );
  const { usedSfids, isLoading } = useGetOpportunitiesRelated(opportunityIds, usedSfidsOnceLoaded);
  return { usedSfids, isLoading: isLoadingOpportunities || isLoading };
}
